import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { Check } from "lucide-react"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider label="Notifications (F8)">
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const safeDescription = description != null ? String(description) : '';
        const isSuccess = variant === 'success';
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex min-w-0 flex-1 items-start gap-3">
              {isSuccess && (
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-100 text-emerald-600" aria-hidden>
                  <Check className="h-5 w-5" strokeWidth={2.5} />
                </div>
              )}
              <div className="grid min-w-0 flex-1 gap-0.5">
                {title != null && title !== '' && <ToastTitle className={isSuccess ? "text-zinc-900" : undefined}>{title}</ToastTitle>}
                {safeDescription !== '' && (
                  <ToastDescription className="text-zinc-600 line-clamp-2">{safeDescription}</ToastDescription>
                )}
              </div>
            </div>
            {action && <div className="shrink-0">{action}</div>}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
